webpackJsonp([1],{

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dai-hua.dfdaf10.jpg";

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Admin__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Table__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_buefy__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy_dist_buefy_css__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy_dist_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_buefy_dist_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mdi_font_css_materialdesignicons_css__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__mdi_font_css_materialdesignicons_css__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_buefy__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
    }, {
        path: '/admin',
        name: 'Admin',
        component: __WEBPACK_IMPORTED_MODULE_3__components_Admin___default.a
    }, {
        path: '/table',
        name: 'table',
        component: __WEBPACK_IMPORTED_MODULE_4__components_Table___default.a
    }],
    mode: 'history'
}));

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(520),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModalForm_vue__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModalForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModalForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        ModalForm: __WEBPACK_IMPORTED_MODULE_0__components_ModalForm_vue___default.a
    },
    data: function data() {
        return {
            isComponentModalActive: false,
            formProps: {
                email: '',
                password: ''
            }
        };
    },

    computed: {
        currentRouteName: function currentRouteName() {
            return this.$route.name;
        }
    },
    methods: {
        logout: function logout() {
            firebase.auth().signOut();
            __WEBPACK_IMPORTED_MODULE_2_buefy__["a" /* ToastProgrammatic */].open({
                duration: 2000,
                message: 'You\'ve logged out successfully',
                type: 'is-success'
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        console.log(this.currentRouteName);
        firebase.auth().onAuthStateChanged(function (firebaseUser) {
            if (firebaseUser) {
                if (_this.currentRouteName === 'Admin') {
                    document.getElementById('clientPortalBtn').classList.add('is-hidden');
                    document.getElementById('homeBtn').classList.remove('is-hidden');
                } else {
                    document.getElementById('clientPortalBtn').classList.remove('is-hidden');
                    document.getElementById('homeBtn').classList.add('is-hidden');
                }
                document.getElementById('loginBtn').classList.add('is-hidden');
                document.getElementById('logoutBtn').classList.remove('is-hidden');
                _this.isComponentModalActive = false;
            } else {
                document.getElementById('loginBtn').classList.remove('is-hidden');
                document.getElementById('logoutBtn').classList.add('is-hidden');
                document.getElementById('clientPortalBtn').classList.add('is-hidden');
                document.getElementById('homeBtn').classList.add('is-hidden');
                _this.$router.push('/');
            }
        });
    }
});

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__client_portal_ManageUsers_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__client_portal_ManageUsers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__client_portal_ManageUsers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__client_portal_DownloadTable_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__client_portal_DownloadTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__client_portal_DownloadTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__client_portal_AdminDownloadTable_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__client_portal_AdminDownloadTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__client_portal_AdminDownloadTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__client_portal_UploadTable_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__client_portal_UploadTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__client_portal_UploadTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_buefy__ = __webpack_require__(22);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// var writeFileAtomic = require('write-file-atomic')
// const worker = require("worker_threads");
// /*
// var functions = require("firebase-functions");
// var admin = require("firebase-admin");
// var cors = require("cors")({ origin: true });
// */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Admin",
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
      isAdmin: false,
      layout: "grid",
      content: "list_file",
      files: [],
      uploadFiles: [],
      sortColumn: "fileName",
      sortOrder: "asc",
      user: {},
      progress: 0,
      isLoading: true,
      isPaginated: true,
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 5,
      defaultOpenedDetails: [1],
      arrUsers: {},
      selectedUser: null,
      notes: null,
      selectedFiles: {},
      sheetURL: "",
      arrSheetURL: []
    }, "isLoading", false);
  },

  watch: {
    perPage: function perPage(val) {
      this.isPaginated = val == 0 ? false : true;
    }
  },
  components: {
    "manage-users": __WEBPACK_IMPORTED_MODULE_4__client_portal_ManageUsers_vue___default.a,
    "download-table": __WEBPACK_IMPORTED_MODULE_5__client_portal_DownloadTable_vue___default.a,
    "admin-download-table": __WEBPACK_IMPORTED_MODULE_6__client_portal_AdminDownloadTable_vue___default.a,
    "upload-table": __WEBPACK_IMPORTED_MODULE_7__client_portal_UploadTable_vue___default.a
  },
  methods: {
    alert: function alert() {
      if (this.isAdmin) {
        window.open("https://screen.daihuamacc.com/#18-fluttering-leopards-jogged-knottily", "", "toolbar=no,location=no");
      } else {
        window.open("https://screen.daihuamacc.com/#host", "", "toolbar=no,location=no");
      }
    },
    users: function users() {
      var that = this;
      var userRef = firebase.database().ref("users").orderByChild("email");
      userRef.once("value", function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          var childKey = childSnapshot.key;
          var childData = childSnapshot.val();
          that.arrUsers[childKey] = childData;
        });
      });
    },
    fetchDownloadDocuments: function fetchDownloadDocuments(uid) {
      var that = this;
      var myFiles = [];

      that.isLoading = true;
      var refDownloadPath = that.isAdmin ? "uploads" : "downloads/" + uid;
      var downloadsRef = firebase.database().ref(refDownloadPath);
      downloadsRef.once("value", function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          var childData = childSnapshot.val();
          if (that.isAdmin) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(childData).forEach(function (childKey) {
              return myFiles.push(childData[childKey]);
            });
          } else {
            myFiles.push(childData);
          }
        });
        that.isLoading = false;
      });
      that.files = myFiles;
    },
    fetchUploadDocuments: function fetchUploadDocuments(uid) {
      var that = this;
      var myUploadFiles = [];

      var refUploadPath = this.isAdmin ? "downloads" : "uploads/" + uid;

      var uploadsRef = firebase.database().ref(refUploadPath);

      uploadsRef.once("value", function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          var childData = childSnapshot.val();
          if (that.isAdmin) {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(childData).forEach(function (childKey) {
              return myUploadFiles.push(childData[childKey]);
            });
          } else {
            myUploadFiles.push(childData);
          }
        });
        that.isLoading = false;
      });

      this.uploadFiles = myUploadFiles;
    },
    fetchUsers: function fetchUsers(uid) {
      var that = this;
      var refUserPath = that.isAdmin ? "users" : "users/" + uid;
      var usersRef = firebase.database().ref(refUserPath);
      usersRef.once("value", function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          var childKey = childSnapshot.key;
          var childData = childSnapshot.val();
          if (that.isAdmin) {
            if (childKey === uid) {
              that.sheetURL = typeof childData.sheetURL !== "undefined" ? childData.sheetURL : "";
            }
            that.arrSheetURL[childKey] = typeof childData.sheetURL !== "undefined" ? childData.sheetURL : "";
          } else {
            if (childKey === "sheetURL") {
              that.sheetURL = typeof childData !== "undefined" ? childData : "";
            }
          }
        });
        that.isLoading = false;
      });
    },
    swap_content: function swap_content(content_type) {
      this.content = content_type;
    },
    clearForm: function clearForm() {
      this.selectedUser = null;
      this.notes = null;
      this.selectedFiles = {};
      this.progress = 0;
    },
    upload: function upload() {
      var that = this;
      var vm = this;
      var storage = firebase.storage();
      var database = firebase.database();
      var user = firebase.auth().currentUser;
      var uid = user.uid;
      var email = user.email;
      var folder = "uploads";
      if (this.isAdmin) {
        uid = this.selectedUser;
        email = this.arrUsers[this.selectedUser].email;
        folder = "downloads";
      }

      // var file = document.getElementById("files").files[0];
      var file = this.selectedFiles;
      var storageRef = firebase.storage().ref();

      var fileExt = this.getFileExtension(file.name);
      var fileName = file.name.replace(/\.[^/.]+$/, "");
      var newFileName = _.snakeCase(fileName) + "_" + this.getDatetime() + "." + fileExt;
      //dynamically set reference to the file name
      var thisRef = storageRef.child("users/" + email + "/" + folder + "/" + newFileName);

      //put request upload file to firebase storage
      thisRef.put(file).on("state_changed", function (snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        that.progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        //   console.log('Upload is ' + that.progress + '% done');
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED:
            // or 'paused'
            //   console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING:
            // or 'running'
            //   console.log('Upload is running');
            break;
        }
      }, function (error) {
        // Handle unsuccessful uploads
      }, function () {
        // Handle successful uploads on complete
        //    console.log('Uploaded a blob or file!');
        console.log(uid);
        // Get a key for a new Post.
        var newPostKey = database.ref().child("users").push().key;
        var updates = {};
        updates["/users/" + uid + "/" + newPostKey] = {
          uid: user.uid,
          email: user.email,
          timestamp: firebase.database.ServerValue.TIMESTAMP
        };
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://api.hostip.info/get_json.php").then(function (response) {
          try {
            updates["/users/" + uid + "/" + newPostKey] = {
              uid: user.uid,
              email: user.email,
              ip: response.data.ip,
              timestamp: firebase.database.ServerValue.TIMESTAMP
            };
            database.ref().update(updates);
          } catch (e) {
            database.ref().update(updates);
          }
        }).catch(function (error) {
          console.log(error);
          database.ref().update(updates);
        });

        thisRef.getMetadata().then(function (metadata) {
          updates["/" + folder + "/" + uid + "/" + newPostKey] = {
            downloadUrl: metadata.downloadURLs[0],
            originalFile: file.name,
            fileExt: fileExt,
            fileName: newFileName,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
            size: metadata.size,
            contentType: metadata.contentType,
            fullPath: metadata.fullPath,
            timeCreated: metadata.timeCreated,
            timeUpdated: metadata.updated,
            notes: that.notes
          };
          database.ref().update(updates);
          //    console.log(metadata);
          __WEBPACK_IMPORTED_MODULE_8_buefy__["a" /* ToastProgrammatic */].open({
            duration: 5000,
            message: "Uploaded Successfully",
            type: "is-success"
          });
          that.clearForm();
          //    window.location.href = '/admin';
          that.fetchDownloadDocuments(uid);
          that.fetchUploadDocuments(uid);
        }).catch(function (error) {
          console.log(error);
          __WEBPACK_IMPORTED_MODULE_8_buefy__["a" /* ToastProgrammatic */].open({
            duration: 5000,
            message: "Your file did not go through. Please upload it again.",
            type: "is-danger"
          });
          // Uh-oh, an error occurred!
        });
      });
    },
    getFileExtension: function getFileExtension(filename) {
      return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
    },
    getDatetime: function getDatetime() {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("YYYYMMDD_HHMMSS");
    },

    setSortColumn: function setSortColumn(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      }
      this.sortColumn = column;
    }
  },
  beforeMount: function beforeMount() {
    this.users();
  },
  mounted: function mounted() {
    var that = this;
    var vm = this;
    firebase.auth().onAuthStateChanged(function (user) {
      var sessionTimeout = null;
      if (user) {
        //   router.push({ name: 'Home'})
        // Fetch the decoded ID token and create a session timeout which signs the user out.
        // user.getIdTokenResult().then((idTokenResult) => {
        // // Make sure all the times are in milliseconds!
        //     const authTime = idTokenResult.claims.auth_time * 1000;
        //     const sessionDuration = 1000 * 60 * 60 * 24 * 30;
        //     const millisecondsUntilExpiration = sessionDuration - (Date.now() - authTime);
        //     sessionTimeout = setTimeout(() => auth.signOut(), millisecondsUntilExpiration);
        // });
        var interval = setInterval(function () {
          // method to be executed;
          user.refreshToken;
          console.log('clear token');
        }, 60000);

        clearInterval(interval);

        that.isAdmin = user.uid === "wv9Xc9RugvRXDDLLpqLxpJQjNim2";

        // user.updateProfile({
        //     displayName: "Steven Chau",
        //     photoURL: "https://avatars3.githubusercontent.com/u/989277?s=460&v=4"
        //   }).then(function() {
        //       console.log('Update successful ');
        //   }).catch(function(error) {
        //       console.log(error);
        //   });

        var uid = user.uid;
        that.fetchDownloadDocuments(uid);
        that.fetchUploadDocuments(uid);
        that.fetchUsers(uid);
      } else {
        // Clear the session timeout.
        // sessionTimeout && clearTimeout(sessionTimeout);
        // sessionTimeout = null;
        var _that = this;
        firebase.auth().signOut().then(function () {
          console.log('sign out');
          _that.$router.push('/');
          // Sign-out successful.
        }).catch(function (error) {
          // An error happened.
        });
      }
    });

    // fileButton.addEventListener('change', function(e){
    //     var file = e.target.files[0];
    //     var storageRef = firebase.storage().ref(file.name);
    //     storageRef.put(file);
    // });
  }
});

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_Profile__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_Gmap__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__home_Gmap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__home_Gmap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_Lessons__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_Lessons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__home_Lessons__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'home',
    components: {
        Profile: __WEBPACK_IMPORTED_MODULE_0__home_Profile___default.a,
        Gmap: __WEBPACK_IMPORTED_MODULE_1__home_Gmap___default.a,
        Lessons: __WEBPACK_IMPORTED_MODULE_2__home_Lessons___default.a
    }
});

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buefy__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            email: '',
            password: ''
        };
    },

    methods: {
        danger: function danger() {
            __WEBPACK_IMPORTED_MODULE_0_buefy__["a" /* ToastProgrammatic */].open({
                duration: 2000,
                message: 'Invalid email or password',
                type: 'is-danger'
            });
            this.password = "";
        },
        login: function login() {
            var _this = this;

            var auth = firebase.auth();
            var promise = auth.signInWithEmailAndPassword(this.email, this.password);
            promise.then(function (e) {
                __WEBPACK_IMPORTED_MODULE_0_buefy__["a" /* ToastProgrammatic */].open({
                    duration: 2000,
                    message: 'You\'ve logged in successfully',
                    type: 'is-success'
                });
                _this.$router.push('/admin');
            }).catch(function (e) {
                return __WEBPACK_IMPORTED_MODULE_0_buefy__["a" /* ToastProgrammatic */].open({
                    duration: 2000,
                    message: 'Invalid email or password',
                    type: 'is-danger'
                });
            });
        }
    }
});

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buefy__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var tableDataSimple = [{ 'id': 1, 'first_name': 'Jesse', 'last_name': 'Simmons', 'date': '2016-10-15 13:43:27', 'gender': 'Male' }, { 'id': 2, 'first_name': 'John', 'last_name': 'Jacobs', 'date': '2016-12-15 06:00:53', 'gender': 'Male' }, { 'id': 3, 'first_name': 'Tina', 'last_name': 'Gilbert', 'date': '2016-04-26 06:26:28', 'gender': 'Female' }, { 'id': 4, 'first_name': 'Clarence', 'last_name': 'Flores', 'date': '2016-04-10 10:28:46', 'gender': 'Male' }, { 'id': 5, 'first_name': 'Anne', 'last_name': 'Lee', 'date': '2016-12-06 14:38:38', 'gender': 'Female' }];

        return {
            tableDataSimple: tableDataSimple,
            defaultOpenedDetails: [1]
        };
    }
});

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['isAdmin', 'files', 'users', 'isLoading'],
    data: function data() {
        return {
            downloadFiles: [],
            sortColumn: 'timeCreated',
            sortOrder: 'desc',
            user: {},
            selectedUser: '',
            progress: 0,
            isPaginated: true,
            defaultSortDirection: 'desc',
            currentPage: 1,
            perPage: 1000,
            defaultOpenedDetails: []
        };
    },

    computed: {
        allUsers: function allUsers() {
            return _.reject(this.users, function (u, i) {
                return !u.email;
            });
        },
        myDownloadFiles: function myDownloadFiles() {
            var that = this;
            this.downloadFiles = _.map(this.files, function (o, i) {
                o.timeExpired = __WEBPACK_IMPORTED_MODULE_0_moment___default()(o.timeCreated).add(60, 'days').toISOString();
                o.id = ++i;
                o.displayName = o.fullPath ? o.fullPath.split('/')[1] : 'Unknown';
                o.photoURL = '';
                return o;
            });

            // filter by email address
            this.downloadFiles = _.filter(this.downloadFiles, function (o, i) {
                if (!that.selectedUser) {
                    return o;
                }
                var email = o.fullPath ? o.fullPath.split('/')[1] : '';
                return email == that.selectedUser;
            });

            // expand details if it has notes
            this.defaultOpenedDetails = _.map(_.filter(this.downloadFiles, 'notes'), 'id');

            return _.orderBy(this.downloadFiles, [this.sortColumn], [this.sortOrder]);
        }
    },
    watch: {
        perPage: function perPage(val) {
            this.isPaginated = val == 0 ? false : true;
        }
    },
    methods: {
        newline_to_br: function newline_to_br(str) {
            if (!str) {
                return 'No Description';
            }
            return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
        }
    },
    filters: {
        date: function date(time) {
            if (time === null) {
                time = 0;
            }

            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('MM/DD/YYYY');
        },
        ago: function ago(time) {
            if (time === null) {
                time = 0;
            }

            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).fromNow();
        },
        capitalize: function capitalize(value) {
            return _.capitalize(value);
        }

    }
});

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['isAdmin', 'files'],
    data: function data() {
        return {
            downloadFiles: [],
            sortColumn: 'timeCreated',
            sortOrder: 'desc',
            user: {},
            progress: 0,
            isLoading: true,
            isPaginated: true,
            defaultSortDirection: 'desc',
            currentPage: 1,
            perPage: 1000,
            defaultOpenedDetails: []
        };
    },

    computed: {
        myDownloadFiles: function myDownloadFiles() {
            this.downloadFiles = _.map(this.files, function (o, i) {
                o.timeExpired = __WEBPACK_IMPORTED_MODULE_0_moment___default()(o.timeCreated).add(60, 'days').toISOString();
                o.id = ++i;
                o.displayName = 'Dai Hua';
                o.photoURL = '';
                return o;
            });
            this.downloadFiles = _.reject(this.downloadFiles, function (o, i) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()(o.timeExpired));
            });

            // expand details if it has notes
            this.defaultOpenedDetails = _.map(_.filter(this.downloadFiles, 'notes'), 'id');

            return _.orderBy(this.downloadFiles, [this.sortColumn], [this.sortOrder]);
        }
    },
    watch: {
        perPage: function perPage(val) {
            this.isPaginated = val == 0 ? false : true;
        }
    },
    filters: {
        date: function date(time) {
            if (time === null) {
                time = 0;
            }

            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('MM/DD/YYYY');
        },
        ago: function ago(time) {
            if (time === null) {
                time = 0;
            }

            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).fromNow();
        },
        capitalize: function capitalize(value) {
            return _.capitalize(value);
        }

    }
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__manage_users_DeleteUserTab_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__manage_users_DeleteUserTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__manage_users_DeleteUserTab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "",
  data: function data() {
    return {
      user: {},
      activeTab: 0
    };
  },
  components: {
    'delete-user-tab': __WEBPACK_IMPORTED_MODULE_1__manage_users_DeleteUserTab_vue___default.a
  },
  methods: {
    deleteTab: function deleteTab() {
      console.log(this.activeTab);
      console.log('delete Tab');
    },
    signUp: function signUp() {
      //Assign default photo url if not provided
      if (!this.user.photo_url) {
        this.user.photo_url = 'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_1280.png';
      }

      if (!this.user.sheet_url) {
        this.user.sheet_url = '';
      }

      var vm = this;
      firebase.auth().createUserWithEmailAndPassword(this.user.email, this.user.password).then(function (user) {
        vm.notify('You have signed in as ' + vm.user.email, 'is-success', 3000);

        //update user profile
        user.updateProfile({
          displayName: _.capitalize(vm.user.first_name) + " " + _.capitalize(vm.user.last_name),
          photoURL: vm.user.photo_url
        }).then(function () {

          var updates = {};
          updates['/users/' + user.uid] = {
            'displayName': _.capitalize(vm.user.first_name) + " " + _.capitalize(vm.user.last_name),
            'email': vm.user.email,
            'firstName': _.capitalize(vm.user.first_name),
            'lastName': _.capitalize(vm.user.last_name),
            'photoURL': vm.user.photo_url,
            'sheetURL': vm.user.sheet_url,
            'createdAt': __WEBPACK_IMPORTED_MODULE_0_moment___default()(firebase.database.ServerValue.TIMESTAMP).toISOString(),
            'timeStamp': firebase.database.ServerValue.TIMESTAMP,
            'roles': {
              admin: false,
              user: true
            }
          };

          firebase.database().ref().update(updates, function () {
            for (var i = 5; i >= 1; i++) {
              vm.notify('Signing out in ' + i + ' seconds', 'is-dark', 1000);
            }
            setTimeout(function () {
              vm.signOut();
            }, 8000);
          });
        }).catch(function (error) {
          console.log(error);
          vm.notify(error.message, 'is-danger');
        });

        //sign out
      }).catch(function (error) {
        vm.notify(error.message, 'is-danger');
      });
    },
    signOut: function signOut() {
      firebase.auth().signOut().then(function () {
        // Sign-out successful, redirect back to home page
        window.location.href = "/";
      }).catch(function (error) {
        console.log(eror);
      });
    },
    notify: function notify(msg, type, time) {
      __WEBPACK_IMPORTED_MODULE_2_buefy__["a" /* ToastProgrammatic */].open({
        duration: time,
        message: msg,
        type: type
      });
    }
  },
  mounted: function mounted() {
    var database = firebase.database();
  }
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['isAdmin', 'files', 'users', 'filterUser'],
    data: function data() {
        return {
            layout: 'grid',
            content: 'list_file',
            uploadFiles: [],
            sortColumn: 'timeCreated',
            sortOrder: 'desc',
            user: {},
            progress: 0,
            isLoading: true,
            isPaginated: true,
            defaultSortDirection: 'desc',
            currentPage: 1,
            perPage: 5,
            defaultOpenedDetails: [],
            arrUsers: {},
            selectedUser: null,
            selectedFilterUser: ''
        };
    },

    watch: {
        perPage: function perPage(val) {
            this.isPaginated = val == 0 ? false : true;
        }
    },
    computed: {
        allUsers: function allUsers() {
            return _.reject(this.users, function (u, i) {
                return !u.email;
            });
        },
        myUploadFiles: function myUploadFiles() {
            var that = this;
            this.uploadFiles = _.map(this.files, function (o, i) {
                o.timeExpired = __WEBPACK_IMPORTED_MODULE_0_moment___default()(o.timeCreated).add(60, 'days').toISOString();
                o.id = ++i;
                //   o.displayName = firebase.auth().currentUser.displayName;
                //   o.photoURL = firebase.auth().currentUser.photoURL
                o.displayName = that.isAdmin ? 'Dai Hua' : o.fullPath ? o.fullPath.split('/')[1] : 'Unknown';
                o.photoURL = '';
                return o;
            });
            if (!this.isAdmin) {
                this.uploadFiles = _.reject(this.uploadFiles, function (o, i) {
                    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()(o.timeExpired));
                });
            } else {
                // filter by email address
                this.uploadFiles = _.filter(this.uploadFiles, function (o, i) {
                    if (!that.selectedFilterUser) {
                        return o;
                    }
                    var email = o.fullPath ? o.fullPath.split('/')[1] : '';
                    return email == that.selectedFilterUser;
                });
            }

            // expand details if it has notes
            this.defaultOpenedDetails = _.map(_.filter(this.uploadFiles, 'notes'), 'id');

            return _.orderBy(this.uploadFiles, [this.sortColumn], [this.sortOrder]);
        }
    },
    methods: {
        newline_to_br: function newline_to_br(str) {
            if (!str) {
                return 'No Description';
            }
            return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
        }
    },
    filters: {
        date: function date(time) {
            if (time === null) {
                time = 0;
            }

            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).format('MM/DD/YYYY');
        },
        ago: function ago(time) {
            if (time === null) {
                time = 0;
            }

            return __WEBPACK_IMPORTED_MODULE_0_moment___default()(time).fromNow();
        },
        capitalize: function capitalize(value) {
            return _.capitalize(value);
        }

    }
});

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buefy__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "",
  data: function data() {
    return {
      userData: [],
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 5
    };
  },

  computed: {
    userList: function userList() {}
  },
  methods: {
    confirmDeleteAccount: function confirmDeleteAccount(id, displayName) {
      var vm = this;
      this.$dialog.confirm({
        title: 'Deleting account',
        message: 'Are you sure you want to <b>delete</b> "' + displayName + '" account? This action cannot be undone.',
        confirmText: 'Delete Account',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: function onConfirm() {

          __WEBPACK_IMPORTED_MODULE_0_buefy__["a" /* ToastProgrammatic */].open('Account deleted!');
        }
      });
    },
    deleteUser: function deleteUser() {
      var user = firebase.auth().currentUser;

      user.delete().then(function () {
        // User deleted.
      }).catch(function (error) {
        // An error happened.
      });
    }
  },
  mounted: function mounted() {
    // let database = firebase.database();
    // let users = database.ref().child('users')
    var query = firebase.database().ref("users").orderByKey();
    var vm = this;
    query.once("value").then(function (snapshot) {
      snapshot.forEach(function (childSnapshot) {
        var objUser = {};
        var key = childSnapshot.key;
        objUser.id = key;
        console.log('key:' + key);
        // childData will be the actual contents of the child
        var childData = childSnapshot.val();
        objUser.displayName = childData.displayName;
        objUser.email = childData.email;
        objUser.firstName = childData.firstName;
        objUser.lastName = childData.lastName;
        objUser.photoURL = childData.photoURL;
        objUser.createdAt = childData.createdAt;

        objUser.roles = childData.roles;
        if (!objUser.roles.admin) {
          vm.userData.push(objUser);
        }
        console.log('childdata:' + childData.displayName);
      });
      console.log(vm.userData);
      admin.auth().getUser(firebase.auth().currentUser.uid).then(function (userRecord) {
        // See the UserRecord reference doc for the contents of userRecord.
        console.log("Successfully fetched user data:", userRecord.toJSON());
      }).catch(function (error) {
        console.log("Error fetching user data:", error);
      });
    });
  }
});

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_google_maps__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(56);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vue2_google_maps__, {
    load: {
        key: 'AIzaSyCllY8AgL62cVSWy6js7NkW8TskOTu2htM'
    }
});

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'gmap',
    data: function data() {
        return {
            center: { lat: 33.5099646, lng: -112.033876 },
            markers: [{
                position: { lat: 33.5099646, lng: -112.033876 }
            }]
        };
    },
    mounted: function mounted() {
        // google.maps.event.addDomListener(window, 'load', initialize);
    }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'lessons',
    data: function data() {
        return {
            lessons: [{
                header: 'IRS Financial & Tax Series',
                body: ['The IRS Financial and Tax Series comprises a series of workshops on taxes for small business owners or entrepreneurs. Topics vary monthly.', '<strong style="color: #e05e07">AMID CORONAVIRUS CONCERNS, ALL CLASSES ARE CANCELED UNTIL FURTHER NOTICE.</strong>']
            }, {
                header: 'Lesson 1 - IRS Series: Federal Taxes and Your Business',
                body: ['Learn the purpose of an EIN number and the fundamental methods between bookkeeping and accounting. Presented by Dai Hua, MACC, using IRS provided information and publications.', '<strong>Registration:</strong> For more information and to register, please visit the <a href="https://www.phoenixpubliclibrary.org/hive/programs/irs-financial-tax-series" target="_blank">hive website</a> or call <a href="tel:16022624636" style="text-decoration:none;">(602) 262-4636</a> during business hours.', '<strong>Sponsored By: </strong> Burton Barr Central Library - The Hive @ Central PHOENIX<br />\
                        <p style="margin-top:10px;">\
                            <strong>Date:</strong> July 12, 2020; January 10, 2021 <br />\
                            <strong>Time:</strong> 2:00 p.m. - 3:00 p.m. <br />\
                            <strong>Location:</strong> <a href="https://www.google.com/maps/place/Burton+Barr+Central+Library/@33.462328,-112.07537,17z/data=!3m1!4b1!4m5!3m4!1s0x872b123fae21ce6b:0x91c09c861ba4ed55!8m2!3d33.462328!4d-112.073176" target="_blank">Burton Barr Central Library - The Hive @ Central, 1221 N Central Ave, 2nd Floor, Phoenix, AZ 85004</a>\
                        </p>']
            }, {
                header: 'Lesson 4 - IRS Series: Running a Business Out of Your Home',
                body: ["Are you starting a home based business? Interested in learning about tax deductions you qualify for? Hear from an expert speaking on behalf of the IRS. Find out what you need to know to take the office-in-the-home deduction including how to qualify, how to determine business percentage, which types of expenses to include, and how to include them. Presented by Dai Hua, MACC, using IRS provided information and publications.", '<strong>Registration:</strong> For more information and to register, please visit the <a href="https://www.phoenixpubliclibrary.org/hive/programs/irs-financial-tax-series" target="_blank">hive website</a> or call <a href="tel:16022624636" style="text-decoration:none;">(602) 262-4636</a> during business hours.', '<strong>Sponsored By: </strong> Burton Barr Central Library - The Hive @ Central PHOENIX<br />\
                        <p style="margin-top:10px;">\
                            <strong>Date:</strong> August 9, 2020; February 14, 2021 <br />\
                            <strong>Time:</strong> 2:00 p.m. - 3:00 p.m. <br />\
                            <strong>Location:</strong> <a href="https://www.google.com/maps/place/Burton+Barr+Central+Library/@33.462328,-112.07537,17z/data=!3m1!4b1!4m5!3m4!1s0x872b123fae21ce6b:0x91c09c861ba4ed55!8m2!3d33.462328!4d-112.073176" target="_blank">Burton Barr Central Library - The Hive @ Central, 1221 N Central Ave, 2nd Floor, Phoenix, AZ 85004</a>\
                        </p>']
            }, {
                header: 'Lesson 6 - IRS Series: Hiring Employees & Contractors',
                body: ["In this workshop, you'll learn about the differences between an employee and an independent contractor; how to determine eligibility to work legally in the United States; the importance of the Form W-4 and the employer's responsibility regarding withholding; how to verify work names and Social Security numbers; the purpose of the state new hire registry; the process for filing Form W-2; your obligations to notify employees about the Earned Income Tax Credit; the role of Individual Taxpayer Identification Numbers; and finally, the process for enrolling in and using the Filing Information Returns Electronically system, also known as FIRE. Presented by Dai Hua, MACC, using IRS provided information and publications.", '<strong>Registration:</strong> For more information and to register, please visit the <a href="https://www.phoenixpubliclibrary.org/hive/programs/irs-financial-tax-series" target="_blank">hive website</a> or call <a href="tel:16022624636" style="text-decoration:none;">(602) 262-4636</a> during business hours.', '<strong>Sponsored By: </strong> Burton Barr Central Library - The Hive @ Central PHOENIX<br />\
                        <p style="margin-top:10px;">\
                            <strong>Date:</strong> September 13, 2020; March 14, 2021<br />\
                            <strong>Time:</strong> 2:00 p.m. - 3:00 p.m. <br />\
                            <strong>Location:</strong> <a href="https://www.google.com/maps/place/Burton+Barr+Central+Library/@33.462328,-112.07537,17z/data=!3m1!4b1!4m5!3m4!1s0x872b123fae21ce6b:0x91c09c861ba4ed55!8m2!3d33.462328!4d-112.073176" target="_blank">Burton Barr Central Library - The Hive @ Central, 1221 N Central Ave, 2nd Floor, Phoenix, AZ 85004</a>\
                        </p>']
            }, {
                header: 'Lesson 7 & 8 - IRS Series: Managing Your Payroll Taxes',
                body: ["In this presentation we'll discuss your responsibilities as an employer to identify wages that are subject to employment taxes, we'll explain the difference between an accountable plan and a non-accountable plan and we'll show you how to calculate your payroll taxes using the appropriate method. We will also discuss the employment tax rules for wages and other types of compensation, as well as, how to make a payroll tax deposit. Presented by Dai Hua, MACC, using IRS provided information and publications.", '<strong>Registration:</strong> For more information and to register, please visit the <a href="https://www.phoenixpubliclibrary.org/hive/programs/irs-financial-tax-series" target="_blank">hive website</a> or call <a href="tel:16022624636" style="text-decoration:none;">(602) 262-4636</a> during business hours.', '<strong>Sponsored By: </strong> Burton Barr Central Library - The Hive @ Central PHOENIX<br />\
                        <p style="margin-top:10px;">\
                            <strong>Date:</strong> October 11, 2020; April 11, 2021 <br />\
                            <strong>Time:</strong> 2:00 p.m. - 3:00 p.m. <br />\
                            <strong>Location:</strong> <a href="https://www.google.com/maps/place/Burton+Barr+Central+Library/@33.462328,-112.07537,17z/data=!3m1!4b1!4m5!3m4!1s0x872b123fae21ce6b:0x91c09c861ba4ed55!8m2!3d33.462328!4d-112.073176" target="_blank">Burton Barr Central Library - The Hive @ Central, 1221 N Central Ave, 2nd Floor, Phoenix, AZ 85004</a>\
                        </p>']
            }]
        };
    }
});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'profile',
    data: function data() {
        return {
            name: 'Dai Hua, MACC LLC',
            about: 'About the Owner',
            work: 'Accounting and Tax Services',
            address1: '2390 E. Camelback Road, Suite 130',
            address2: 'Phoenix, AZ 85016',
            phone1: '(602) 456-2DAI',
            phone2: '(602) 456-2324',
            email: 'Dai@daihuamacc.com',
            website: 'www.daihuamacc.com'
        };
    }
});

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(292);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 370:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 372:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 161,
	"./af.js": 161,
	"./ar": 168,
	"./ar-dz": 162,
	"./ar-dz.js": 162,
	"./ar-kw": 163,
	"./ar-kw.js": 163,
	"./ar-ly": 164,
	"./ar-ly.js": 164,
	"./ar-ma": 165,
	"./ar-ma.js": 165,
	"./ar-sa": 166,
	"./ar-sa.js": 166,
	"./ar-tn": 167,
	"./ar-tn.js": 167,
	"./ar.js": 168,
	"./az": 169,
	"./az.js": 169,
	"./be": 170,
	"./be.js": 170,
	"./bg": 171,
	"./bg.js": 171,
	"./bm": 172,
	"./bm.js": 172,
	"./bn": 173,
	"./bn.js": 173,
	"./bo": 174,
	"./bo.js": 174,
	"./br": 175,
	"./br.js": 175,
	"./bs": 176,
	"./bs.js": 176,
	"./ca": 177,
	"./ca.js": 177,
	"./cs": 178,
	"./cs.js": 178,
	"./cv": 179,
	"./cv.js": 179,
	"./cy": 180,
	"./cy.js": 180,
	"./da": 181,
	"./da.js": 181,
	"./de": 184,
	"./de-at": 182,
	"./de-at.js": 182,
	"./de-ch": 183,
	"./de-ch.js": 183,
	"./de.js": 184,
	"./dv": 185,
	"./dv.js": 185,
	"./el": 186,
	"./el.js": 186,
	"./en-SG": 187,
	"./en-SG.js": 187,
	"./en-au": 188,
	"./en-au.js": 188,
	"./en-ca": 189,
	"./en-ca.js": 189,
	"./en-gb": 190,
	"./en-gb.js": 190,
	"./en-ie": 191,
	"./en-ie.js": 191,
	"./en-il": 192,
	"./en-il.js": 192,
	"./en-nz": 193,
	"./en-nz.js": 193,
	"./eo": 194,
	"./eo.js": 194,
	"./es": 197,
	"./es-do": 195,
	"./es-do.js": 195,
	"./es-us": 196,
	"./es-us.js": 196,
	"./es.js": 197,
	"./et": 198,
	"./et.js": 198,
	"./eu": 199,
	"./eu.js": 199,
	"./fa": 200,
	"./fa.js": 200,
	"./fi": 201,
	"./fi.js": 201,
	"./fo": 202,
	"./fo.js": 202,
	"./fr": 205,
	"./fr-ca": 203,
	"./fr-ca.js": 203,
	"./fr-ch": 204,
	"./fr-ch.js": 204,
	"./fr.js": 205,
	"./fy": 206,
	"./fy.js": 206,
	"./ga": 207,
	"./ga.js": 207,
	"./gd": 208,
	"./gd.js": 208,
	"./gl": 209,
	"./gl.js": 209,
	"./gom-latn": 210,
	"./gom-latn.js": 210,
	"./gu": 211,
	"./gu.js": 211,
	"./he": 212,
	"./he.js": 212,
	"./hi": 213,
	"./hi.js": 213,
	"./hr": 214,
	"./hr.js": 214,
	"./hu": 215,
	"./hu.js": 215,
	"./hy-am": 216,
	"./hy-am.js": 216,
	"./id": 217,
	"./id.js": 217,
	"./is": 218,
	"./is.js": 218,
	"./it": 220,
	"./it-ch": 219,
	"./it-ch.js": 219,
	"./it.js": 220,
	"./ja": 221,
	"./ja.js": 221,
	"./jv": 222,
	"./jv.js": 222,
	"./ka": 223,
	"./ka.js": 223,
	"./kk": 224,
	"./kk.js": 224,
	"./km": 225,
	"./km.js": 225,
	"./kn": 226,
	"./kn.js": 226,
	"./ko": 227,
	"./ko.js": 227,
	"./ku": 228,
	"./ku.js": 228,
	"./ky": 229,
	"./ky.js": 229,
	"./lb": 230,
	"./lb.js": 230,
	"./lo": 231,
	"./lo.js": 231,
	"./lt": 232,
	"./lt.js": 232,
	"./lv": 233,
	"./lv.js": 233,
	"./me": 234,
	"./me.js": 234,
	"./mi": 235,
	"./mi.js": 235,
	"./mk": 236,
	"./mk.js": 236,
	"./ml": 237,
	"./ml.js": 237,
	"./mn": 238,
	"./mn.js": 238,
	"./mr": 239,
	"./mr.js": 239,
	"./ms": 241,
	"./ms-my": 240,
	"./ms-my.js": 240,
	"./ms.js": 241,
	"./mt": 242,
	"./mt.js": 242,
	"./my": 243,
	"./my.js": 243,
	"./nb": 244,
	"./nb.js": 244,
	"./ne": 245,
	"./ne.js": 245,
	"./nl": 247,
	"./nl-be": 246,
	"./nl-be.js": 246,
	"./nl.js": 247,
	"./nn": 248,
	"./nn.js": 248,
	"./pa-in": 249,
	"./pa-in.js": 249,
	"./pl": 250,
	"./pl.js": 250,
	"./pt": 252,
	"./pt-br": 251,
	"./pt-br.js": 251,
	"./pt.js": 252,
	"./ro": 253,
	"./ro.js": 253,
	"./ru": 254,
	"./ru.js": 254,
	"./sd": 255,
	"./sd.js": 255,
	"./se": 256,
	"./se.js": 256,
	"./si": 257,
	"./si.js": 257,
	"./sk": 258,
	"./sk.js": 258,
	"./sl": 259,
	"./sl.js": 259,
	"./sq": 260,
	"./sq.js": 260,
	"./sr": 262,
	"./sr-cyrl": 261,
	"./sr-cyrl.js": 261,
	"./sr.js": 262,
	"./ss": 263,
	"./ss.js": 263,
	"./sv": 264,
	"./sv.js": 264,
	"./sw": 265,
	"./sw.js": 265,
	"./ta": 266,
	"./ta.js": 266,
	"./te": 267,
	"./te.js": 267,
	"./tet": 268,
	"./tet.js": 268,
	"./tg": 269,
	"./tg.js": 269,
	"./th": 270,
	"./th.js": 270,
	"./tl-ph": 271,
	"./tl-ph.js": 271,
	"./tlh": 272,
	"./tlh.js": 272,
	"./tr": 273,
	"./tr.js": 273,
	"./tzl": 274,
	"./tzl.js": 274,
	"./tzm": 276,
	"./tzm-latn": 275,
	"./tzm-latn.js": 275,
	"./tzm.js": 276,
	"./ug-cn": 277,
	"./ug-cn.js": 277,
	"./uk": 278,
	"./uk.js": 278,
	"./ur": 279,
	"./ur.js": 279,
	"./uz": 281,
	"./uz-latn": 280,
	"./uz-latn.js": 280,
	"./uz.js": 281,
	"./vi": 282,
	"./vi.js": 282,
	"./x-pseudo": 283,
	"./x-pseudo.js": 283,
	"./yo": 284,
	"./yo.js": 284,
	"./zh-cn": 285,
	"./zh-cn.js": 285,
	"./zh-hk": 286,
	"./zh-hk.js": 286,
	"./zh-tw": 287,
	"./zh-tw.js": 287
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(512),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(508),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(518),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(517),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(513),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(506),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(509),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(521),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b08a4990",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(372)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(522),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(516),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b1dd262",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4441b91e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(373)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(523),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ea3aebca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(507),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-26f963c5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(514),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63069bf6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(515),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(510),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(519),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 506:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('b-loading', {
    attrs: {
      "active": _vm.isLoading,
      "canCancel": true
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-fullheight"
  }, [_c('div', {
    staticClass: "column is-2 is-sidebar-menu"
  }, [_c('aside', {
    staticClass: "menu"
  }, [(_vm.isAdmin) ? _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n            General\n        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('a', {
    class: _vm.content == 'list_file' ? 'is-active' : 'color-white',
    on: {
      "click": function($event) {
        return _vm.swap_content('list_file')
      }
    }
  }, [_vm._v("\n                Download Documents\n            ")])]), _vm._v(" "), _c('li', [_vm._v(" ")]), _vm._v(" "), _c('li', [_c('a', {
    class: _vm.content == 'upload_file' ? 'is-active' : 'color-white',
    on: {
      "click": function($event) {
        return _vm.swap_content('upload_file')
      }
    }
  }, [_vm._v("\n                Upload Documents\n            ")])]), _vm._v(" "), (_vm.sheetURL) ? _c('li', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.sheetURL) ? _c('li', [_c('a', {
    class: _vm.content == 'timesheet' ? 'is-active' : 'color-white',
    on: {
      "click": function($event) {
        return _vm.swap_content('timesheet')
      }
    }
  }, [_vm._v("\n                Payroll Worksheet\n            ")])]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(" ")]), _vm._v(" "), _c('li', [_c('a', {
    class: _vm.content == 'share_screen' ? 'is-active' : 'color-white',
    on: {
      "click": function($event) {
        return _vm.alert()
      }
    }
  }, [_vm._v("\n                Share Screen " + _vm._s(_vm.isAdmin ? '(Chrome)' : '') + "\n            ")])])]), _vm._v(" "), (_vm.isAdmin) ? _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n            Administration\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('ul', {
    staticClass: "menu-list"
  }, [(_vm.isAdmin) ? _c('li', [_c('a', {
    class: _vm.content == 'manage_user' ? 'is-active' : 'color-white',
    on: {
      "click": function($event) {
        return _vm.swap_content('manage_user')
      }
    }
  }, [_vm._v("Manage Users")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column is-main-content"
  }, [(_vm.content == 'list_file') ? _c('div', [(_vm.isAdmin) ? _c('div', [_c('admin-download-table', {
    attrs: {
      "isAdmin": _vm.isAdmin,
      "files": _vm.files,
      "users": _vm.arrUsers,
      "isLoading": _vm.isLoading
    }
  })], 1) : _c('div', {}, [_c('download-table', {
    attrs: {
      "isAdmin": _vm.isAdmin,
      "files": _vm.files,
      "isLoading": _vm.isLoading
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.content == 'upload_file') ? _c('div', [_c('upload-table', {
    attrs: {
      "isAdmin": _vm.isAdmin,
      "files": _vm.uploadFiles,
      "users": _vm.arrUsers
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter is-hidden-touch"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }],
    staticClass: "textarea is-info",
    attrs: {
      "name": "upload_note",
      "rows": "5",
      "placeholder": "Enter your notes here..."
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "file is-centered is-boxed is-default has-name"
  }, [_c('label', [_c('b-field', {
    staticClass: "file"
  }, [_c('b-upload', {
    model: {
      value: (_vm.selectedFiles),
      callback: function($$v) {
        _vm.selectedFiles = $$v
      },
      expression: "selectedFiles"
    }
  }, [_c('a', {
    staticClass: "button is-default"
  }, [_c('b-icon', {
    attrs: {
      "icon": "upload"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Choose file")])], 1)]), _vm._v(" "), (_vm.selectedFiles) ? _c('span', {
    staticClass: "file-name"
  }, [_vm._v("\n                        " + _vm._s(_vm.selectedFiles.name ? _vm.selectedFiles.name : 'No file chosen') + "\n                        ")]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('progress', {
    staticClass: "progress is-primary",
    attrs: {
      "id": "upload_progress_bar",
      "max": "100"
    },
    domProps: {
      "value": _vm.progress
    }
  }, [_vm._v(_vm._s(_vm.progress) + "%")]), _vm._v(" "), (_vm.isAdmin) ? _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("For Client:")]), _vm._v(" "), _c('b-select', {
    attrs: {
      "expanded": true
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }, _vm._l((_vm.arrUsers), function(user, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": id
      }
    }, [(!user.email) ? [_vm._v("\n                        -- Select One --\n                    ")] : [_vm._v("\n                        " + _vm._s(user.displayName) + " (" + _vm._s(user.email) + ")\n                    ")]], 2)
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "button is-large is-primary",
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": _vm.isAdmin && !_vm.selectedUser
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("Submit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-quarter is-hidden-touch"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.content == 'timesheet') ? _c('div', {
    staticClass: "has-text-centered"
  }, [(_vm.isAdmin) ? _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('br'), _vm._v(" "), _c('b-select', {
    attrs: {
      "expanded": true
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }, _vm._l((_vm.arrUsers), function(user, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": id
      }
    }, [(!user.email) ? [_vm._v("\n                    -- Select One --\n                    ")] : [_vm._v("\n                    " + _vm._s(user.displayName) + " (" + _vm._s(user.email) + ")\n                    ")]], 2)
  }), 0), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), (_vm.arrSheetURL[_vm.selectedUser]) ? _c('iframe', {
    staticStyle: {
      "overflow": "hidden",
      "height": "800px",
      "width": "100%"
    },
    attrs: {
      "src": _vm.arrSheetURL[_vm.selectedUser],
      "frameborder": "0",
      "marginheight": "0",
      "marginwidth": "0",
      "width": "100%",
      "height": "100%",
      "scrolling": "auto"
    }
  }) : _vm._e()]) : _c('div', [(_vm.sheetURL) ? _c('iframe', {
    staticStyle: {
      "overflow": "hidden",
      "height": "800px",
      "width": "100%"
    },
    attrs: {
      "src": _vm.sheetURL,
      "frameborder": "0",
      "marginheight": "0",
      "marginwidth": "0",
      "width": "100%",
      "height": "100%",
      "scrolling": "auto"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.content == 'share_screen') ? _c('div', {
    staticClass: "has-text-centered"
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "type": "is-primary"
    },
    on: {
      "click": _vm.alert
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isAdmin ? 'View Client Shared Screen' : 'Open Shared Screen Window') + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.content == 'manage_user' && _vm.isAdmin) ? _c('div', [(_vm.isAdmin) ? _c('manage-users') : _vm._e()], 1) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "upload-documents"
    }
  }, [_c('div', {
    staticClass: "level-right",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.isAdmin) ? _c('div', {
    staticClass: "level-item"
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-select', {
    attrs: {
      "expanded": true
    },
    model: {
      value: (_vm.selectedFilterUser),
      callback: function($$v) {
        _vm.selectedFilterUser = $$v
      },
      expression: "selectedFilterUser"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- All Users --")]), _vm._v(" "), _vm._l((_vm.allUsers), function(user, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": user.email
      }
    }, [_vm._v("\n                        " + _vm._s(user.displayName) + " (" + _vm._s(user.email) + ")\n                    ")])
  })], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }, [_c('option', {
    attrs: {
      "value": "1000"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 per page")])])], 1)], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.myUploadFiles,
      "paginated": _vm.isPaginated,
      "stickyHeaders:": "",
      "true": "",
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "default-sort-direction": _vm.defaultSortDirection,
      "default-sort": "timeCreated",
      "opened-detailed": _vm.defaultOpenedDetails,
      "detailed": "",
      "detail-key": "id"
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "visible": false
          }
        }, [_vm._v("\n                " + _vm._s(props.row.id) + "\n            ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "fileName",
            "label": "File Name",
            "sortable": ""
          }
        }, [_c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.originalFile) + "\n                ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "timeCreated",
            "label": "Creation Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                    " + _vm._s(new Date(props.row.timeCreated).toLocaleDateString()) + "\n                ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "timeExpired",
            "label": "Expiration Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                    " + _vm._s(new Date(props.row.timeExpired).toLocaleDateString()) + "\n                ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "fileExt",
            "label": "Type",
            "sortable": "",
            "right": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                    " + _vm._s(props.row.fileExt) + "\n                ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "size",
            "label": "Size",
            "sortable": "",
            "numeric": ""
          }
        }, [_c('span', {
          staticClass: "tag",
          staticStyle: {
            "background-color": "initial"
          }
        }, [_vm._v("\n                    " + _vm._s(Math.ceil(props.row.size / 1000)) + "KB\n                ")])])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return [_c('article', {
          staticClass: "media"
        }, [_c('figure', {
          staticClass: "media-left"
        }, [_c('p', {
          staticClass: "image is-96x96"
        }, [_c('img', {
          attrs: {
            "src": '/static/img/icons/512px/' + props.row.fileExt.toLowerCase() + '.png',
            "alt": props.row.fileName
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('h4', {
          staticClass: "title is-4",
          staticStyle: {
            "margin-top": "0",
            "margin-bottom": "5px"
          }
        }, [_c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v("\n                                    " + _vm._s(props.row.originalFile) + "\n                                ")]), _vm._v(" "), _c('small', [_vm._v("\n                                    ("), _c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(props.row.fileName))]), _vm._v(")\n                                ")])]), _vm._v(" "), _c('em', [_vm._v("\n                                Uploaded By\n                                    "), (props.row.photoURL) ? _c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": props.row.photoURL,
            "alt": "",
            "width": "16"
          }
        }) : _vm._e(), _vm._v(" "), (props.row.displayName) ? _c('strong', [_vm._v(_vm._s(props.row.displayName))]) : _c('strong', [_vm._v("You")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("ago")(props.row.timeCreated)))])]), _vm._v(" "), _c('p', [_c('em', {
          domProps: {
            "innerHTML": _vm._s(_vm.newline_to_br(props.row.notes))
          }
        })])])])])]
      }
    }])
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [_c('b-table-column', {
    attrs: {
      "field": "fileName",
      "label": "File Name"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "timeCreated",
      "label": "Creation Date"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "timeExpired",
      "label": "Expiration Date"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "fileExt",
      "label": "Type"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "size",
      "label": "Size"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c('p', [_vm._v("There are no recent files.")])])])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "//fonts.googleapis.com/icon?family=Material+Icons"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered is-desktop is-tablet"
  }, [_c('div', {
    staticClass: "column is-hidden-mobile"
  }, [_c('article', {
    staticClass: "media"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('profile')], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column is-hidden-tablet"
  }, [_c('profile')], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('gmap')], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 20px 0 20px"
    }
  }, [_c('lessons'), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "media-left m-t-20"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(289),
      "alt": "Dai Hua"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-hidden-tablet"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(289),
      "alt": "Dai Hua"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-dark"
  }, [_c('div', {
    staticClass: "hero-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h3', [_vm._v("Source: "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://www.irs.gov/businesses/small-businesses-self-employed/arizona-tax-workshops-meetings-and-seminars",
      "target": "_blank"
    }
  }, [_vm._v("IRS Tax Workshops, Meetings and Seminars")])]), _vm._v(" "), _c('h3', [_vm._v("Register for classes at: "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "https://www.phoenixpubliclibrary.org/hive/programs/irs-financial-tax-series",
      "target": "_blank"
    }
  }, [_vm._v("Phoenix Library Website")])])])])])
}]}

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-t-20 m-b-20"
  }, _vm._l((_vm.lessons), function(objLesson) {
    return _c('article', {
      staticClass: "message is-black"
    }, [_c('div', {
      staticClass: "message-header"
    }, [_c('h1', [_vm._v(_vm._s(objLesson.header))])]), _vm._v(" "), _c('div', {
      staticClass: "message-body"
    }, _vm._l((objLesson.body), function(body) {
      return _c('p', {
        staticStyle: {
          "margin-bottom": "10px"
        },
        domProps: {
          "innerHTML": _vm._s(body)
        }
      })
    }), 0)])
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "level-right",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }, [_c('option', {
    attrs: {
      "value": "1000"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 per page")])])], 1)], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.myDownloadFiles,
      "paginated": _vm.isPaginated,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "default-sort-direction": _vm.defaultSortDirection,
      "default-sort": "timeCreated",
      "opened-detailed": _vm.defaultOpenedDetails,
      "detailed": "",
      "detail-key": "id"
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "visible": false
          }
        }, [_vm._v("\n              " + _vm._s(props.row.id) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "fileName",
            "label": "File Name",
            "sortable": ""
          }
        }, [_c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v("\n                  " + _vm._s(props.row.originalFile) + "\n              ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "timeCreated",
            "label": "Creation Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                  " + _vm._s(new Date(props.row.timeCreated).toLocaleDateString()) + "\n              ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "timeExpired",
            "label": "Expiration Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                  " + _vm._s(new Date(props.row.timeExpired).toLocaleDateString()) + "\n              ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "fileExt",
            "label": "Type",
            "sortable": "",
            "right": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                  " + _vm._s(props.row.fileExt) + "\n              ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "size",
            "label": "Size",
            "sortable": "",
            "numeric": ""
          }
        }, [_c('span', {
          staticClass: "tag",
          staticStyle: {
            "background-color": "initial"
          }
        }, [_vm._v("\n                  " + _vm._s(Math.ceil(props.row.size / 1000)) + "KB\n              ")])])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return [_c('article', {
          staticClass: "media"
        }, [_c('figure', {
          staticClass: "media-left"
        }, [_c('p', {
          staticClass: "image is-96x96"
        }, [_c('img', {
          attrs: {
            "src": '/static/img/icons/512px/' + props.row.fileExt.toLowerCase() + '.png',
            "alt": props.row.fileName
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('h4', {
          staticClass: "title is-4",
          staticStyle: {
            "margin-top": "0",
            "margin-bottom": "5px"
          }
        }, [_c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v("\n                                  " + _vm._s(props.row.originalFile) + "\n                              ")]), _vm._v(" "), _c('small', [_vm._v("\n                                  ("), _c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(props.row.fileName))]), _vm._v(")\n                              ")])]), _vm._v(" "), _c('em', [_vm._v("\n                              Uploaded By\n                                  "), (props.row.photoURL) ? _c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": props.row.photoURL,
            "alt": "",
            "width": "16"
          }
        }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(props.row.displayName))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("ago")(props.row.timeCreated)))])]), _vm._v(" "), _c('p', [_c('em', [_vm._v(_vm._s(props.row.notes ? props.row.notes : 'No description'))])])])])])]
      }
    }])
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [_c('b-table-column', {
    attrs: {
      "field": "fileName",
      "label": "File Name"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "timeCreated",
      "label": "Creation Date"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "timeExpired",
      "label": "Expiration Date"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "fileExt",
      "label": "Type"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "size",
      "label": "Size"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c('p', [_vm._v("There are no recent files.")])])])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('br'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 per page")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-flex"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isPaginated),
      callback: function($$v) {
        _vm.isPaginated = $$v
      },
      expression: "isPaginated"
    }
  }, [_vm._v("Paginated")])], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.userData,
      "paginated": _vm.isPaginated,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "pagination-simple": _vm.isPaginationSimple,
      "default-sort-direction": 'asc',
      "default-sort": "firstName"
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "firstName",
            "label": "First Name",
            "sortable": ""
          }
        }, [_vm._v("\n                  " + _vm._s(props.row.firstName) + "\n              ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "lastName",
            "label": "Last Name",
            "sortable": ""
          }
        }, [_vm._v("\n                  " + _vm._s(props.row.lastName) + "\n              ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "createdAt",
            "label": "Created",
            "sortable": ""
          }
        }, [_vm._v("\n                  " + _vm._s(props.row.createdAt) + "\n              ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "email",
            "label": "Email",
            "sortable": ""
          }
        }, [_c('a', {
          attrs: {
            "href": 'mailto:' + props.row.email
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.email) + "\n                  ")])]), _vm._v(" "), _c('b-table-column', [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDeleteAccount(props.row.id, props.row.displayName)
            }
          }
        }, [_c('b-icon', {
          attrs: {
            "icon": "cancel",
            "custom-class": "button-danger"
          }
        })], 1)])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gmap-map', {
    staticClass: "m-t-20",
    staticStyle: {
      "width": "400px",
      "height": "500px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 14,
      "map-type-id": "terrain"
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "level-right",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-select', {
    attrs: {
      "expanded": true
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- All Users --")]), _vm._v(" "), _vm._l((_vm.allUsers), function(user, id) {
    return _c('option', {
      key: id,
      domProps: {
        "value": user.email
      }
    }, [_vm._v("\n                      " + _vm._s(user.displayName) + " (" + _vm._s(user.email) + ")\n                  ")])
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }, [_c('option', {
    attrs: {
      "value": "1000"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 per page")])])], 1)], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.myDownloadFiles,
      "paginated": _vm.isPaginated,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "default-sort-direction": _vm.defaultSortDirection,
      "default-sort": "timeCreated",
      "opened-detailed": _vm.defaultOpenedDetails,
      "loading": _vm.isLoading,
      "detailed": "",
      "detail-key": "id"
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "visible": false
          }
        }, [_vm._v("\n              " + _vm._s(props.row.id) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "fileName",
            "label": "File Name",
            "sortable": ""
          }
        }, [_c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v("\n                  " + _vm._s(props.row.originalFile) + "\n              ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "timeCreated",
            "label": "Creation Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                  " + _vm._s(new Date(props.row.timeCreated).toLocaleDateString()) + "\n              ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "timeExpired",
            "label": "Expiration Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                  " + _vm._s(new Date(props.row.timeExpired).toLocaleDateString()) + "\n              ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "fileExt",
            "label": "Type",
            "sortable": "",
            "right": ""
          }
        }, [_c('span', {
          staticClass: "tag is-default"
        }, [_vm._v("\n                  " + _vm._s(props.row.fileExt) + "\n              ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "size",
            "label": "Size",
            "sortable": "",
            "numeric": ""
          }
        }, [_c('span', {
          staticClass: "tag",
          staticStyle: {
            "background-color": "initial"
          }
        }, [_vm._v("\n                  " + _vm._s(Math.ceil(props.row.size / 1000)) + "KB\n              ")])])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return [_c('article', {
          staticClass: "media"
        }, [_c('figure', {
          staticClass: "media-left"
        }, [_c('p', {
          staticClass: "image is-96x96"
        }, [_c('img', {
          attrs: {
            "src": '/static/img/icons/512px/' + props.row.fileExt.toLowerCase() + '.png',
            "alt": props.row.fileName
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('h4', {
          staticClass: "title is-4",
          staticStyle: {
            "margin-top": "0",
            "margin-bottom": "5px"
          }
        }, [_c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v("\n                                  " + _vm._s(props.row.originalFile) + "\n                              ")]), _vm._v(" "), _c('small', [_vm._v("\n                                  ("), _c('a', {
          attrs: {
            "href": props.row.downloadUrl,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(props.row.fileName))]), _vm._v(")\n                              ")])]), _vm._v(" "), _c('em', [_vm._v("\n                              Uploaded By\n                                  "), (props.row.photoURL) ? _c('img', {
          staticClass: "img-circle",
          attrs: {
            "src": props.row.photoURL,
            "alt": "",
            "width": "16"
          }
        }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(props.row.displayName))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("ago")(props.row.timeCreated)))])]), _vm._v(" "), _c('p', [_c('em', {
          domProps: {
            "innerHTML": _vm._s(_vm.newline_to_br(props.row.notes))
          }
        })])])])])]
      }
    }])
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [_c('b-table-column', {
    attrs: {
      "field": "fileName",
      "label": "File Name"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "timeCreated",
      "label": "Creation Date"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "timeExpired",
      "label": "Expiration Date"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "fileExt",
      "label": "Type"
    }
  }), _vm._v(" "), _c('b-table-column', {
    attrs: {
      "field": "size",
      "label": "Size"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c('p', [_vm._v("There are no recent files.")])])])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.0)",
      "color": "white",
      "border": "none"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('td', [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "block"
  }, [_c('b-icon', {
    attrs: {
      "icon": "account",
      "size": "is-medium"
    }
  })], 1)]), _vm._v(" "), _c('td', [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.about)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('ul', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('li', [_vm._v("Bachelor of Science in Accountancy from"), _c('b-tooltip', {
    attrs: {
      "label": "Arizona State University",
      "position": "is-right"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("ASU")])]), _vm._v("\n                    - 2011"), _c('br'), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "label": "with the highest distinction",
      "position": "is-right"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Graduated Summa Cum Laude")])])], 1), _vm._v(" "), _c('li', [_vm._v("Master of Accountancy (MACC) from"), _c('b-tooltip', {
    attrs: {
      "label": "Arizona State University",
      "position": "is-right"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("ASU")])]), _vm._v(" - 2012")], 1), _vm._v(" "), _c('li', [_vm._v("Work in Public Accounting Field - Since 2012")]), _vm._v(" "), _c('li', [_vm._v("Teach IRS Financial & Tax Series - Since 2015")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "block"
  }, [_c('b-icon', {
    attrs: {
      "icon": "briefcase-variant",
      "size": "is-medium"
    }
  })], 1)]), _vm._v(" "), _c('td', [_c('h2', [_vm._v(_vm._s(_vm.work))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "block"
  }, [_c('b-icon', {
    attrs: {
      "icon": "mailbox",
      "size": "is-medium"
    }
  })], 1)]), _vm._v(" "), _c('td', [_c('h2', [_vm._v(_vm._s(_vm.address1))])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('h2', [_vm._v(_vm._s(_vm.address2))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "block"
  }, [_c('b-icon', {
    attrs: {
      "icon": "phone-classic",
      "size": "is-medium"
    }
  })], 1)]), _vm._v(" "), _c('td', [_c('h2', [_vm._v(_vm._s(_vm.phone1) + " - " + _vm._s(_vm.phone2))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "block"
  }, [_c('b-icon', {
    attrs: {
      "icon": "email",
      "size": "is-medium"
    }
  })], 1)]), _vm._v(" "), _c('td', [_c('h2', [_vm._v(_vm._s(_vm.email))])])])])
},staticRenderFns: []}

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "level-right"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "id": "loginBtn"
    },
    on: {
      "click": function($event) {
        _vm.isComponentModalActive = true
      }
    }
  }, [_vm._v("Client Login")]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-medium is-hidden",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": "/admin",
      "id": "clientPortalBtn"
    }
  }, [_vm._v("Client Portal")]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-medium is-hidden",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": "/",
      "id": "homeBtn"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-medium is-hidden",
    attrs: {
      "id": "logoutBtn"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isComponentModalActive
    },
    on: {
      "update:active": function($event) {
        _vm.isComponentModalActive = $event
      }
    }
  }, [_c('modal-form', _vm._b({}, 'modal-form', _vm.formProps, false))], 1)], 1), _vm._v(" "), _c('main', [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-field', {
    attrs: {
      "label": "Email"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Your email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "password-reveal": "",
      "placeholder": "Your password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('b-checkbox', [_vm._v("Remember me")])], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$parent.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.login()
      }
    }
  }, [_vm._v("Login")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Login")])])
}]}

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    attrs: {
      "data": _vm.tableDataSimple,
      "opened-detailed": _vm.defaultOpenedDetails,
      "detailed": "",
      "detail-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": "ID",
            "width": "40",
            "numeric": ""
          }
        }, [_vm._v("\n            " + _vm._s(props.row.id) + "\n        ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "First Name"
          }
        }, [_vm._v("\n            " + _vm._s(props.row.first_name) + "\n        ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Last Name"
          }
        }, [_vm._v("\n            " + _vm._s(props.row.last_name) + "\n        ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Date",
            "centered": ""
          }
        }, [_vm._v("\n            " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n        ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_vm._v("\n            " + _vm._s(props.row.gender) + "\n        ")])]
      }
    }, {
      key: "detail",
      fn: function(props) {
        return [_c('article', {
          staticClass: "media"
        }, [_c('figure', {
          staticClass: "media-left"
        }, [_c('p', {
          staticClass: "image is-64x64"
        }, [_c('img', {
          attrs: {
            "src": "static/img/placeholder-128x128.png"
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('p', [_c('strong', [_vm._v(_vm._s(props.row.first_name) + " " + _vm._s(props.row.last_name))]), _vm._v(" "), _c('small', [_vm._v("@" + _vm._s(props.row.first_name))]), _vm._v(" "), _c('small', [_vm._v("31m")]), _vm._v(" "), _c('br'), _vm._v("\n                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                        Proin ornare magna eros, eu pellentesque tortor vestibulum ut.\n                        Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.\n                    ")])])])])]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-tabs', {
    attrs: {
      "type": "is-boxed"
    },
    on: {
      "change": function($event) {
        return _vm.deleteTab()
      }
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('b-tab-item', {
    attrs: {
      "label": "Create New User"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-three-quarters"
  }, [_c('p', [_vm._v("Please fill out the form to create a new user.")]), _vm._v(" "), _c('section', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "First Name"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "First Name",
      "type": "text"
    },
    model: {
      value: (_vm.user.first_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "first_name", $$v)
      },
      expression: "user.first_name"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Last Name"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Last Name",
      "type": "text"
    },
    model: {
      value: (_vm.user.last_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "last_name", $$v)
      },
      expression: "user.last_name"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Email"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Email",
      "type": "email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password",
      "value": "",
      "password-reveal": ""
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Photo URL"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "photo_url",
      "type": "url"
    },
    model: {
      value: (_vm.user.photo_url),
      callback: function($$v) {
        _vm.$set(_vm.user, "photo_url", $$v)
      },
      expression: "user.photo_url"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Google Sheet URL"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Google Spread Sheet URL",
      "type": "url"
    },
    model: {
      value: (_vm.user.sheet_url),
      callback: function($$v) {
        _vm.$set(_vm.user, "sheet_url", $$v)
      },
      expression: "user.sheet_url"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "button is-primary is-medium ",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.signUp()
      }
    }
  }, [_vm._v("Submit")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  })])]), _vm._v(" "), _c('b-tab-item', {
    attrs: {
      "label": "Update User"
    }
  }), _vm._v(" "), _c('b-tab-item', {
    attrs: {
      "label": "Detele User"
    }
  }, [(_vm.activeTab === 2) ? _c('delete-user-tab') : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

},[330]);


// WEBPACK FOOTER //
// static/js/app.ce24418de4b012174ee4.js